module.exports = __webpack_public_path__ + "img/fm-Path 40 Copy@3x.fac1923c.png";